module.exports = __webpack_public_path__ + "media/images/header-logo-alt-24a298c629a5578152f23fe007d1e34b.svg";